import React from 'react';
import Button from '../button/Button';
import styles from './DashboardFilters.module.css';

function DashboardFilters({
  phone,
  startDate,
  endDate,
  onPhoneChange,
  onStartDate,
  onEndDate,
  onApply,
  loading,
  children,
}) {
  return (
    <div className={styles.filters}>
      <div className={styles.group}>
        <label>Phone Number</label>
        <input
          type="text"
          placeholder="e.g. +1234567890"
          value={phone}
          onChange={(e) => onPhoneChange(e.target.value)}
        />
      </div>
      <div className={styles.group}>
        <label>Start Date</label>
        <input
          type="date"
          value={startDate}
          onChange={(e) => onStartDate(e.target.value)}
        />
      </div>
      <div className={styles.group}>
        <label>End Date</label>
        <input
          type="date"
          value={endDate}
          onChange={(e) => onEndDate(e.target.value)}
        />
      </div>
      {children}
      <Button
        className={styles.updateBtn}
        onClick={onApply}
        disabled={loading}
      >
        Update
      </Button>
    </div>
  );
}

export default DashboardFilters;
